// extracted by mini-css-extract-plugin
module.exports = {"h1ap76is":"h1ap76is","c1531pnh":"c1531pnh"};